/**
 * A provider's name as a BI dashboard shows it (CU-869fmjzrg, Curro's review with real data). The names come from
 * `MASTER_PROVIDERS.name` (webback → `ProviderTranslationService`); some rows hold what a scraper read from a logo, e.g.
 * ".doyouspain.com/cdn/img/prv/flat/mid/logo_glf.png". A URL or a file path is never shown as a name: the fallback is
 * "Provider #<id>". Pure and alias-free.
 */
const LOOKS_LIKE_URL = /(^https?:)|(^www\.)|(^\.)|(\/)|(\.(png|jpe?g|gif|svg|webp)(\?.*)?$)/i

export const isBadProviderName = name => {
	const s = String(name ?? '').trim()
	return !s || LOOKS_LIKE_URL.test(s)
}

export const providerName = (name, id) => (isBadProviderName(name) ? `Provider #${id}` : String(name).trim())

/** The answer with every provider's name made presentable (`providers: [{ id, name }]`) */
export function withCleanProviderNames(data) {
	if (!data?.providers?.length) return data
	const providers = data.providers.map(p => (isBadProviderName(p.name) ? { ...p, name: providerName(p.name, p.id), rawName: p.name } : p))
	return providers.some((p, i) => p !== data.providers[i]) ? { ...data, providers } : data
}
